<template>
    <div v-if="description" class="description">

        <div class="text" v-html="description"
             :class="{'truncate':cut}"
             :style="{maxHeight:maxHeight}"
             ref="description"></div>

        <div v-if="displayReadMore" class="text-center">
            <router-link v-if="route" class="link" :to="route">
                {{t('more')}}
            </router-link>
            <button v-else type="button" class="btn btn-link btn-sm" @click="cut=!cut">{{t('more')}}</button>
        </div>
    </div>
</template>

<script>

    export default {
        name: "ProductsListProductDescription",
        props: {
            description: String,
            maxHeight: Number,
            route: {}
        },
        data() {

            return {
                t_path: "components.products.list.product.description",
                displayReadMore: false,
                cut: true,
                timeout: null
            }
        },
        methods: {
            handleDisplayReadMore() {

                if (this.$refs.description) {

                    const $clone = this.$refs.description.cloneNode(true);
                    const computedStyle = window.getComputedStyle(this.$refs.description);
                    const rect = this.$refs.description.getBoundingClientRect();

                    $clone.classList.remove("truncate");

                    $clone.style.position = "absolute";
                    $clone.style.width = computedStyle["width"];
                    $clone.style.top = 0;
                    $clone.style.left = -2 * (rect.left + parseInt(computedStyle["width"]));

                    document.body.appendChild($clone);
                    this.displayReadMore = computedStyle["height"] != window.getComputedStyle($clone)["height"]
                    document.body.removeChild($clone);
                }
            }
        },
        watch: {
            description: {
                immediate: true,
                handler() {

                    clearInterval(this.timeout);
                    this.timeout = setInterval(() => {

                        if (this.$refs.description) {

                            this.handleDisplayReadMore();
                            clearInterval(this.timeout);
                        }
                    }, 10);
                }
            }
        }
    }
</script>